export default "__VITE_ASSET__87NOr1eC__"